/** Lista factual de capacidades da plataforma, usada em schema, llms e páginas GEO. */
export const FABCHAT_FEATURE_LIST = [
  "Agentes de IA configuráveis para WhatsApp e Instagram",
  "CRM nativo com funil de leads",
  "Negociações (pipeline comercial)",
  "Catálogo de produtos, serviços e planos",
  "Disparo de mensagens em massa no WhatsApp (API oficial Cloud e conexão por QR)",
  "Agendamento de mensagens",
  "Respostas a Direct e comentários no Instagram",
  "Tarefas da equipe",
  "Aprimorar mensagens com IA",
  "Recuperação de lead com sugestão de respostas",
  "Resumo e métricas de atendimento",
  "Agendamentos com Google Calendar",
] as const;

export const GEO_FEATURE_PATHS = [
  "/whatsapp/disparos",
  "/recuperacao-de-leads",
  "/agendar-mensagens",
  "/catalogo-de-produtos",
  "/negociacoes",
  "/tarefas",
  "/aprimorar-mensagens",
  "/analise-de-atendimento",
] as const;
